import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

/** Piles its children in a column with a 24px gap. */
export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex flex-col gap-6", className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Stack.displayName = "Stack";
